import PropTypes from 'prop-types';
import React from 'react';

import ListItem from './ListItem';
import SelectedOption from './SelectedOption';
import { Button, List, SelectedOptionsList, Title, Wrapper } from './DesktopDropdown.style';

class DekstopDropdown extends React.Component {
  static defaultProps = {
    title: undefined,
  };

  static propTypes = {
    active: PropTypes.arrayOf(PropTypes.string).isRequired,
    id: PropTypes.string.isRequired,
    label: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
    onUpdate: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(PropTypes.string).isRequired,
    title: PropTypes.string,
  };

  state = {
    open: false,
  };

  componentWillMount = () => {
    document.addEventListener('click', this.handleClickOutside);
  };

  componentWillUnmount = () => {
    document.removeEventListener('click', this.handleClickOutside);
  };

  button = React.createRef();

  handleClickOutside = e => {
    if (this.button && this.button.current && !this.button.current.contains(e.target)) {
      this.setState({ open: false });
    }
  };

  handleListItemClicked = (label, selected) => {
    const { active } = this.props;
    let newActive;
    if (label === 'All') {
      newActive = [];
    } else if (selected) {
      newActive = active.filter(option => option !== label);
    } else {
      newActive = active.concat(label);
    }
    this.props.onUpdate({ [this.props.id]: newActive });
  };

  handleSelectedOptionClicked = label => {
    const active = this.props.active.filter(option => option !== label);
    this.props.onUpdate({ [this.props.id]: active });
  };

  handleOpen = () => this.setState(({ open }) => ({ open: !open }));

  render() {
    const { open } = this.state;
    const { active, label, options, title } = this.props;

    return (
      <Wrapper open={open}>
        {title && <Title>{title}</Title>}
        <Button onClick={this.handleOpen} innerRef={this.button} open={open}>
          {label}
        </Button>

        {active.length > 0 && (
          <SelectedOptionsList>
            {active.map(option => (
              <SelectedOption key={option} label={option} onClick={this.handleSelectedOptionClicked} />
            ))}
          </SelectedOptionsList>
        )}

        <List open={open}>
          <ListItem label="All" onClick={this.handleListItemClicked} selected={active.length === 0} />
          {options.map(option => (
            <ListItem
              key={option}
              label={option}
              onClick={this.handleListItemClicked}
              selected={active.indexOf(option) >= 0}
            />
          ))}
        </List>
      </Wrapper>
    );
  }
}

export default DekstopDropdown;



// WEBPACK FOOTER //
// ./src/components/DropdownMenu/DesktopDropdown/DesktopDropdown.js